import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: ReactNode;
  className?: string;
  alternate?: boolean;
  id?: string;
}
export function Section({
  children,
  className = '',
  alternate = false,
  id
}: SectionProps) {
  return <section id={id} className={`w-full py-20 md:py-28 px-6 flex justify-center ${alternate ? 'bg-warm-800' : 'bg-warm-900'} ${className}`} data-id="element-206">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.8,
      ease: 'easeOut'
    }} className="w-full max-w-2xl" data-id="element-207">
        {children}
      </motion.div>
    </section>;
}